import { useRef } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@roger/ui-components';
import { ArrowLeft, Download } from 'lucide-react';
import AdoptionReport, {
  type AdoptionReportRef,
} from '../components/reports/AdoptionReport';
import { useReportsBackHref } from '../reporting/backHref';
import ReportsPermissionAlert from './ReportsPermissionAlert';
import { useStore } from '../store';
import { useShallow } from 'zustand/react/shallow';

const AdoptionReportPage = () => {
  const { hasPermission } = useStore(
    useShallow(state => ({
      hasPermission: state.hasPermission,
    }))
  );
  const adoptionReportRef = useRef<AdoptionReportRef>(null);
  const reportsBackHref = useReportsBackHref();

  if (!hasPermission('reports:access')) {
    return <ReportsPermissionAlert />;
  }

  return (
    <div className='space-y-6'>
      <Link
        to={reportsBackHref}
        className='inline-flex items-center text-sm font-medium text-muted-foreground hover:text-foreground'
      >
        <ArrowLeft className='mr-1 h-4 w-4' />
        Reports
      </Link>

      <div className='flex items-center'>
        <Button
          variant='outline'
          className='px-3 text-xs'
          onClick={() => adoptionReportRef.current?.exportToCSV()}
          size='default'
        >
          <Download className='h-4 w-4' />
          Download Report
        </Button>
      </div>

      <AdoptionReport ref={adoptionReportRef} />
    </div>
  );
};

export default AdoptionReportPage;
